import AppRoutes from '@/components/AppRoutes.tsx';
import { useKayAuth } from '@/context/AuthContext.tsx';
import { loadPlain, resetPlain } from '@/lib/plain.ts';
import Login from '@/screens/Login.tsx';
import { SignedIn, SignedOut, useAuth, useUser } from '@clerk/clerk-react';
import React, { useEffect } from 'react';

const ProtectedRoute: React.FC = () => {
  const { user, validateAuth } = useKayAuth();
  const { isSignedIn } = useAuth();
  const { user: clerkUser } = useUser();
  const userId = user?.user_id;
  const fullName = clerkUser?.fullName ?? undefined;
  const shortName = clerkUser?.firstName ?? undefined;

  useEffect(() => {
    if (!isSignedIn) {
      resetPlain();
      return;
    }
    if (!userId) {
      return;
    }

    loadPlain({ fullName, id: userId, shortName });
  }, [isSignedIn, userId, fullName, shortName]);

  useEffect(() => {
    if (isSignedIn) {
      validateAuth();
    }
  }, [isSignedIn]);

  return (
    <>
      <SignedOut>
        <Login />
      </SignedOut>
      <SignedIn>
        <AppRoutes />
      </SignedIn>
    </>
  );
};

export default ProtectedRoute;
